import React from "react";

export const LOGO_SRC = "https://customer-assets-jt897jd0.emergentagent.net/job_vision-value-growth/artifacts/kxiy6s7x_IMG_0012%202.jpeg";

// Ethikally interlocking-triangle mark (uploaded)
export const Logo = ({ className = "h-10 w-10" }) => (
  <img src={LOGO_SRC} alt="Ethikally" className={`object-contain ${className}`} />
);

export const Wordmark = ({ light = false }) => (
  <div className="flex items-center gap-2.5">
    <Logo className="h-9 w-9" />
    <div className="leading-none">
      <span className={`font-heading text-2xl font-semibold tracking-tight ${light ? "text-cream" : "text-navy"}`}>
        Ethikally
      </span>
    </div>
  </div>
);
